import { NgModule } from '@angular/core';

import { LoadingComponent } from '../loading/loading.component';
import { ToastComponent } from '../toast/toast.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { ConfigPanelComponent } from './config-panel/config-panel.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [
    LoadingComponent,
    ToastComponent
  ],
  imports: [
    CommonModule,
    PageHeaderComponent,
    ConfigPanelComponent,
    InfoModalComponent
  ],
  exports: [
    LoadingComponent,
    ToastComponent,
    PageHeaderComponent,
    ConfigPanelComponent,
    InfoModalComponent
  ]
})
export class SharedModule { }